import { useEffect, useState } from "react";
import { alertService } from "@/services/api";

// Nav badge count — was a hardcoded `8` in navConfig.js regardless of what
// the Alerts page actually showed. Polls lightly so it doesn't drift too far
// out of sync while acknowledging/resolving alerts elsewhere in the app.
export function useNewAlertsCount() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      alertService
        .list({ status: "new" })
        .then((list) => { if (!cancelled) setCount(list.length); })
        .catch(() => {});
    };
    load();
    const interval = setInterval(load, 30000);
    return () => { cancelled = true; clearInterval(interval); };
  }, []);

  return count;
}
